<template>
  <div>
    <div class="templateInfo div-layout">
      <module-title title="模板信息" />
      <el-form class="searchForm" :inline="true" label-position="right" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="searchForm.title" name="title" placeholder="请输入标题" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="短信模板" prop="template">
          <el-input v-model="searchForm.template" name="template" placeholder="请输入短信模板" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="应用学校" prop="schoolName">
          <el-input v-model="searchForm.schoolName" name="schoolName" placeholder="请输入应用学校" class="handle-form-input" />
        </el-form-item>
        <el-form-item style="margin-left:15px;">
          <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="listLoading" :data="viewData" highlight-current-row fit element-loading-text="Loading" class="list-table">
        <el-table-column label="序号" type="index" width="55" align="center" />
        <el-table-column label="标题" prop="title" align="center" />
        <el-table-column label="短信模板" prop="template" align="center">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="top-start">
              <div slot="content">
                {{ scope.row.template }}
              </div>
              <div class="ellipsis">
                {{ scope.row.template }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="应用学校" prop="schools" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.schoolName.toString()" placement="top-start">
              <span v-for="(v,i) in scope.row.schools" :key="i">
                {{ v.schoolName }}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="sppliedSchool(scope.row)">
              应用学校
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="page.total" :page.sync="page.pageNum" :limit.sync="page.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
      <el-dialog :close-on-click-modal="false" :visible.sync="schoolVisible" title="应用学校" width="800px" @close="cancleSchoolVisible">
        <div class="applySchool">
          <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
            全选
          </el-checkbox>
          <div style="margin: 15px 0;" />
          <el-checkbox-group v-model="checkedSchoolList" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="(item,index) in schoolList" :key="index" :label="item.schoolCode">
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="cancleSchoolVisible">
            取消
          </el-button>
          <el-button type="primary" size="medium" @click="submitApplySchool">
            提交
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getTemplatesPageList, getApplySchool } from '@/api/messageCenter/index.js';
import { getBackdropsSchool } from '@/api/productOperation/youthTrack/desktopBackgroundManage';
export default {
  data() {
    return {
      searchForm: {
        schoolName: '',
        template: '',
        title: ''
      },
      schoolVisible: false,
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      viewData: [],
      option: {},
      detailInfo: {},
      schoolList: [],
      checkAll: false,
      checkedSchoolList: [],
      isIndeterminate: true
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    submitApplySchool() {
      const op = {
        templateId: this.detailInfo.id,
        schoolCodes: this.checkedSchoolList
      };
      getApplySchool(op).then(res => {
        this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
        this.cancleSchoolVisible();
        this.getTableList();
      });
    },
    cancleSchoolVisible() {
      this.schoolVisible = false;
      this.checkedSchoolList = [];
    },
    handleCheckAllChange(val) {
      const data = this.schoolList.map(item => {
        return item.schoolCode;
      });
      this.checkedSchoolList = val ? data : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.schoolList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.schoolList.length;
    },
    sppliedSchool(row) {
      const schoolCode = row.schools.map(item => item.schoolCode);
      this.checkedSchoolList = schoolCode;
      this.detailInfo = row;
      this.schoolVisible = true;
      this.getSchoolList();
    },
    getSchoolList() {
      getBackdropsSchool().then(res => {
        this.schoolList = res.data;
      });
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        schoolName: this.searchForm.schoolName,
        template: this.searchForm.template,
        title: this.searchForm.title
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getTemplatesPageList({ ...this.option, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.viewData = [];
          this.page.total = 0;
        } else {
          // this.viewData = res.data.list;
          this.viewData = res.data.list.map(item => {
            const schoolName = item.schools.map(item => item.schoolName);
            return { ...item, schoolName: schoolName };
          });
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.templateInfo{
  .ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
}
</style>
<style lang="scss">
.applySchool{
  .el-checkbox-group{
    line-height: 30px;
  }
}
</style>
